// CacheKey 02189c26b437ca838f30e3f667054d5b
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-PAYER": {
    models: {
      blueprint: "workflow",
      patient: "member",
      patients: "members",
      Patient: "Member",
      Patients: "Members",
      patient_tags: "Tags",
      comment: "comment",
      comments: "comments",
      Comment: "Comment",
      Comments: "Comments"
    },
    admitted_patients: {
      title: "Admitted Members"
    },
    workflows: {
      title: "Workflows"
    },
    monitored_patients: {
      title: "Monitored Members"
    },
    my_patient_panel: {
      title: "My Member Panel"
    },
    patients_search: {
      nav_menu: "Members"
    },
    plans: {
      patient_information: "Member Info"
    }
  }
}

